import { useEffect } from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { REQUEST_CHANGE_ROUTER } from './IwRouter.actions';

type TRedirect = {
    pathname: string;
    searchString?: string;
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    redirectToURL: ({ pathname, searchString }: TRedirect) => {
        if (searchString) {
            dispatch({
                type: REQUEST_CHANGE_ROUTER,
                location: { pathname: pathname, search: `?${searchString}` }
            });
        } else
            dispatch({
                type: REQUEST_CHANGE_ROUTER,
                location: { pathname: pathname }
            });
    }
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const IwRedirect = ({
    pathname,
    searchString,
    redirectToURL
}: TRedirect & PropsFromRedux) => {
    useEffect(() => {
        redirectToURL({ pathname, searchString });
    }, [redirectToURL, pathname, searchString]);
    return null;
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(IwRedirect);
